<template>
  <!-- <BreadCrumb PageTitle="Register" /> -->
  <TransactionSuccessContent />
</template>

<script lang="ts">
import { onMounted,defineComponent } from "vue";
import stateStore from "../../utils/store";

//import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransactionSuccessContent from "../../components/Public/Ticket/TransactionSuccessContent.vue";

export default defineComponent({
  name: "TransactionSuccessPage",
  components: {
    //BreadCrumb,
    TransactionSuccessContent,
  },
  setup(){
        const stateStoreInstance = stateStore;
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");        
        onMounted(() => {
          stateStoreInstance.show = false;
        });
       return {stateStoreInstance};
  }
});
</script>